




















import { Component, Prop, Vue } from "vue-property-decorator"
import AppProgramaPresentacion from "@/components/Programa/AppProgramaPresentacion.vue";
import { ProgramaDia } from "@/Interfaces/Programa/ProgramaDia";

@Component({
  components: {
    AppProgramaPresentacion
  }
})
export default class AppProgramaDia extends Vue {
  @Prop({ required: true }) programaDias: ProgramaDia;
  @Prop({ default: false }) becario: boolean
}
